let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = Promise.all([load("4X3wS"), load("hSQJ5"), load("aCh9P"), load("bxxT5"), load("22gjn")]).then(() => parcelRequire('aBLDN'));